import differenceInDays from 'date-fns/differenceInDays';
import differenceInHours from 'date-fns/differenceInHours';
import differenceInMinutes from 'date-fns/differenceInMinutes';
import differenceInMonths from 'date-fns/differenceInMonths';
import differenceInYears from 'date-fns/differenceInYears';
import format from 'date-fns/format';
import isSameDay from 'date-fns/isSameDay';
import isSameWeek from 'date-fns/isSameWeek';
import enGB from 'date-fns/locale/en-GB';
import fr from 'date-fns/locale/fr';
import parse from 'date-fns/parse';
import { config } from '../../env';
import { EEnvLocale } from '../../env.types';

export const getHourFromDate = (stringDate: string) => {
  return format(stringDate, 'HH:mm');
};

export const formatMessageDate = (stringDate: string): string => {
  const options = getLocaleOptions();
  const date = parseApiDate(stringDate);

  if (isSameDay(date, new Date())) {
    return format(date, 'HH:mm');
  }

  if (isSameWeek(date, new Date())) {
    return capitalize(format(date, 'EEEE', options));
  }

  return format(date, 'P', options);
};

export const formatDate = (date: Date, formatPattern: string): string => {
  const options = getLocaleOptions();

  return format(date, formatPattern, options);
};

export const getLocaleOptions = (): object => ({
  locale: config.env.locale === EEnvLocale.fr ? fr : enGB,
});

const capitalize = (toCap: string) => {
  return toCap.charAt(0).toUpperCase() + toCap.slice(1);
};

export const parseApiDate = (apiDate: string) =>
  parse(apiDate, "yyyy-MM-dd'T'HH:mm:ssXX", new Date());

export const computeAge = (date: string) =>
  Math.abs(differenceInYears(date, new Date()));

export const timeSinceLastConnection = (date: string) => {
  const now = new Date();

  if (differenceInMinutes(now, date) < 5) {
    return 'online';
  } else if (differenceInHours(now, date) < 24) {
    return '24hours';
  } else if (differenceInHours(now, date) < 48) {
    return '48hours';
  } else if (differenceInHours(now, date) < 72) {
    return '3days';
  } else if (differenceInDays(now, date) < 8) {
    return 'week';
  } else if (differenceInMonths(now, date) < 1) {
    return 'month';
  }

  return;
};

export const WEEK_IN_DAYS = 7;
export const MONTH_IN_DAYS = 30;
export const YEAR_IN_DAYS = 365;
export const DAY_IN_MS = 86400000;
